import React from 'react';
import '../styles/FormulairesContact.css';
import Musee from '../assets/formulairesdecontact/museetdm.jpg';
import AAMTDM from '../assets/logo-aamtdm.jpg';
import Chetom from '../assets/chetom/lechetom.jpg'

function FormulairesContact() {
  return (
    <>
      <section className="hero fade-in">
        <h1>Formulaires de contact Musée - CHETOM - Association</h1>
        <p>Sélectionnez l'entité que vous souhaitez contacter pour être redirigé vers le formulaire approprié.</p>
      </section>

      <section className="content-section fade-in">
        <h2 style={{ marginBottom: '4rem' }}>Qui souhaitez-vous contacter ?</h2>

        <div className="section fade-in">
          <img src={Musee} alt="Le Musée des Troupes de Marine" />
          <div className="text-content">
            <h3>Le Musée des Troupes de Marine</h3>
            <p>Conservatoire de riches collections, le musée des Troupes de marine est à la fois un lieu de mémoire et de commémoration ; un musée d'histoire, de sciences et de techniques, d'arts et de traditions militaires ; et un pôle d'activités culturelles (expositions, conférences), de partage et d'aventures humaines. Au gré de ses 1 100 m² de surface d'exposition, le musée retrace l'Histoire des Troupes de marine. Il présente leurs différentes spécialités, la spécificité de leurs théâtres d'engagement et leurs grandes figures militaires. Le musée accueille plus de 17 000 visiteurs par an, et expose environ 4 500 objets.</p>
            <div className="btn-section">
              <a className="btn" href="/pages/formulairemusee">Contacter le Musée des Troupes de Marine</a>
            </div>
          </div>
        </div>

        <div className="section reverse fade-in">
          <img src={AAMTDM} style={{ height: '15em' }} alt="L'Association des Amis du Musée des Troupes de Marine" />
          <div className="text-content">
            <h3>L'Association des Amis du Musée des Troupes de Marine</h3>
            <p>Créée en 1979, les Amis du Musée des Troupes de marine est une association qui apporte son concours à l’enrichissement, à la conservation, à la mise en valeur et au rayonnement du patrimoine culturel et artistique constitué par les collections du musée, lesquelles témoignent de l’engagement et des vertus militaires dont les Troupes de la Marine avant 1900 puis les troupes coloniales de 1900 à 1958 et enfin les Troupes de marine ont fait preuve au service de la France.</p>
            <div className="btn-section">
              <a className="btn" href="/pages/formulaireassociation">Contacter l'AAMTDM</a>
            </div>
          </div>
        </div>

        <div className="section fade-in">
          <img src={Chetom} alt="Le CHETOM" />
          <div className="text-content">
            <h3>Le CHETOM</h3>
            <p>Le Centre d’histoire et d’études des Troupes d’Outre-Mer naît en 1996, à l’initiative du conservateur du musée des troupes de marine de l’époque. L’idée est alors de réunir en un seul lieu tous les éléments spécifiques à l’histoires de ces troupes, à l’histoire militaire de la France de l’Outre-Mer. Convaincu par cette démarche, le général, inspecteur des troupes de marine, décide, en août 1996, de transférer au musée de Fréjus, l’ensemble des archives et du fond bibliographique ancien appartenant au centre militaire d’information et de documentation sur l’Outre-Mer (CMIDOM), alors en garnison à Versailles. Un arrêté ministériel, daté du 15 novembre 1996 et paru dans le journal officiel du 21 décembre suivant, institue le CHETOM comme dépôt d’archives du ministère de la Défense, dépendant du Service Historique de l’Armée de Terre (SHAT).</p>
            <div className="btn-section">
              <a className="btn" href="/pages/formulairechetom">Contacter le CHETOM</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FormulairesContact;
